import React, { useEffect } from "react";
import "../AboutUs/MeetTheTeam.css";
import Footer from "../../Components/Navigation/Footer";
import Navigation from "../../Components/Navigation/Navigation";
import Naveed from "../../Assets/Images/AboutUs/Naveed.jpg";
import Guney from "../../Assets/Images/AboutUs/Guney.jpg";
import Ellie from "../../Assets/Images/AboutUs/Eliie.jpg";
import Aida from "../../Assets/Images/AboutUs/Aida.jpg";
import ZenStamp from "../../Assets/Images/AboutUs/zen-stamp.svg";
import Building from "../../Assets/Images/AboutUs/building.jpeg";
import Banner from "../../Components/Banner";
import BannerImage from "../../Assets/Images/Banner/meet-the-team.jpg";

function MeetTheTeam() {
  useEffect(() => {
    document.title = "Meet The Team | Zen Homes";
  }, []);
  return (
    <div className="aboutUsContainer">
      <Navigation
        linkColor="black"
        submenuColor="black"
        menuIconColor="black"
      />
      <Banner title="Meet The Team" backgroundImage={BannerImage} />
      <div className="meetTeamContainer">
        <div className="intro">
          <h1>A one-of-a-kind local estate agency.</h1>
          <p>
            With deep local expertise and a commitment to exceptional service,
            we navigate the property market with integrity and insight. Whether
            buying, selling, or letting, we provide tailored guidance to help
            you make informed decisions with confidence.
          </p>
          <img src={ZenStamp} alt="Zen Home Stamp" />
        </div>

        <div className="teamContainer">
          {/* Team Member 1 */}
          <div className="teamImage">
            <img src={Guney} alt="Guney - Director" />
          </div>
          <div className="teamInfo">
            <h1 className="teamName">Guney Gultekin - Director</h1>
            <div className="teamAbout">
              <p>
                Beginning his career as a young apprentice, Guney Gultekin has
                dedicated the last 10 years solely to estate agency. Over this
                time, he has amassed extensive knowledge in lettings and
                significant experience in sales. Guney takes pride in being
                attentive to clients, building strong customer relationships,
                and serving as a trustworthy agent.
              </p>
              <p>
                A resident of Enfield, Guney has developed a profound
                understanding of the borough, including its properties and the
                local community. His insights and expertise enable him to
                provide invaluable support to clients navigating the property
                market.
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/guney-gultekin-960042354"
                  target="_blank"
                  className="linkedIn"
                >
                  <i className="fab fa-linkedin"></i>Connect with Guney
                </a>
              </p>
            </div>
          </div>
          {/* Team Member 2 */}
          <div className="teamInfo">
            <h1 className="teamName">Naveed Kazi – Director</h1>
            <div className="teamAbout">
              <p>
                With over 15 years of experience in corporate estate agency,
                Naveed Kazi possesses a solid foundation in sales complemented
                by extensive knowledge in lettings. Having worked with one of
                the UK's largest estate agency groups and as a member of the
                National Association of Estate Agents (NAEA), he brings a wealth
                of expertise to the table.
              </p>
              <p>
                Born and raised in Haringey, Naveed has an intimate
                understanding of the local area. His greatest strength lies in
                his deep connection to the community and his ability to navigate
                the market with ease. He is particularly adept at guiding
                newcomers to the area, helping them seamlessly acclimatise and
                find properties that meet their needs.
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/naveed-kazi-55b963137"
                  target="_blank"
                  className="linkedIn"
                >
                  <i className="fab fa-linkedin"></i>Connect with Naveed
                </a>
              </p>
            </div>
          </div>
          <div className="teamImage">
            <img src={Naveed} alt="Naveed - Director" />
          </div>
          {/* Team Member 3 */}
          <div className="teamImage">
            <img src={Ellie} alt="Ellie - Lettings Negotiator" />
          </div>
          <div className="teamInfo">
            <h1 className="teamName">Ellie Koumbas - Lettings Negotiator</h1>
            <div className="teamAbout">
              <p>
                With emerging experience in the property industry, Ellie Koumbas
                is supported by a strong background in customer service and a
                meticulous attention to detail. Her professional approach and
                strong communication skills enable her to build trusted
                relationships and deliver a consistently high standard of
                service to clients.
              </p>
              <p>
                Alongside her role, she is studying for a Marketing Degree with
                Honours, which has provided her with valuable insight into
                consumer behaviour and digital marketing strategies. As a
                dedicated and driven estate agent, she places great importance
                on clear communication, realistic expectation management, and
                always acting in her clients' best interests, ensuring a smooth
                and professional experience throughout the letting process.
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/ellie-koumbas-a73610268"
                  target="_blank"
                  className="linkedIn"
                >
                  <i className="fab fa-linkedin"></i>Connect with Ellie
                </a>
              </p>
            </div>
          </div>
          {/* Team Member 4 */}
          <div className="teamInfo">
            <h1 className="teamName">Aida Aramideh – Lettings Negotiator</h1>
            <div className="teamAbout">
              <p>
                Joined the property industry three years ago and has since
                developed a strong and lasting passion for real estate. During
                this time, Aida Aramideh has gained valuable experience across a
                range of departments, including sales, lettings, and property
                management, providing a comprehensive understanding of the
                property lifecycle and the needs of both landlords and tenants.
              </p>
              <p>
                With an academic background and a degree in Bachelor of Laws
                (LLB), Aida brings a robust legal and commercial perspective to
                the role, ensuring that transactions are handled with care,
                accuracy, and professionalism. This knowledge, combined with a
                proactive approach and genuine enthusiasm for the property
                sector, allows her to deliver a consistently high standard of
                service. She is committed to building strong client
                relationships and is known for providing informed, reliable, and
                professional advice throughout every stage of the property
                process.
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/aida-aramideh-527425114"
                  target="_blank"
                  className="linkedIn"
                >
                  <i className="fab fa-linkedin"></i>Connect with Aida
                </a>
              </p>
            </div>
          </div>
          <div className="teamImage">
            <img src={Aida} alt="Aida - Lettings Negotiator" className="teamMemberA" />
          </div>
        </div>
      </div>
      <div className="ctaContainer">
        <div className="ctaImage">
          <img src={Building} alt="building" />
        </div>
        <div className="ctaInfo">
          <h1 className="ctaHeading">
            Supported by a Trusted and Experienced Estate Agency
          </h1>
          <p className="ctaText">
            With a solid foundation and years of industry expertise, our agency
            is built on trust, reliability, and a deep understanding of the
            local market. We provide unparalleled support, ensuring seamless
            property transactions with professionalism and integrity.
          </p>
          <div className="ctaButtons">
            <button className="ctaButton1">
              <a href="/lettings">View Our Lettings Properties</a>
            </button>
            <br />
            <button className="ctaButton2">
              <a href="book-valuation">Book a Valuation</a>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MeetTheTeam;
